export default {
  youSaveDisplay: {
    id: 'product_page_you_save_amount_display',
    defaultMessage: 'Save {reduction}',
  },
  bundlingDiscount: {
    id: 'funnel_cart_bundle_discount',
    defaultMessage: 'Bundling saved you {price}',
  },
  vatIncluded: {
    id: 'product_price_label_vat_included',
    defaultMessage: 'tax included',
  },
  productRefurbishedPriceLabel: {
    id: 'product_page_refurbished_price_label',
    defaultMessage: 'Refurbished price',
  },
}
